import ThreeUp from "../../components/ThreeUp";
import ThreeUpItem from "../../components/ThreeUp/components/ThreeUpItem";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { notNull } from "../../utils/type-guards/general";

const ThreeUpInspirationModule = ({
	headline,
	label,
	items,
}: Queries.ThreeUpInspirationModuleFragment) => (
	<GridItem>
		<ThreeUp headline={headline ?? ""} label={label ?? ""}>
			{items
				?.filter(notNull)
				.map(
					(item) =>
						item.link_text &&
						item.image?.filename && (
							<ThreeUpItem
								key={item.link_text}
								headline={item.link_text}
								image={item.image}
								href={getUrlFromStoryblokLink(item.link)}
							/>
						),
				)}
		</ThreeUp>
	</GridItem>
);

export default ThreeUpInspirationModule;
